export const getBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result!.toString());
    reader.onerror = reject;
});

export const uploadImage = (accept: string = 'image/png, image/jpeg'): Promise<File> =>
  new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.click();

    input.onchange = () => {
      if (!input.files) return;
      const file = input.files[0];
      resolve(file);
    };

    input.oncancel = () => {
      reject();
    };
  });
